<template>
    <div class="technologies">
        <section class="page">
            <header class="main">
                <div class="container">
                    <h4>About Me</h4>
                </div>
            </header>
            <div class="page-content">
				<div class="container">
					<div class="row">
						<div class="col-6">
							<h1>Tomasz Zaborski</h1>
							<p>I am a Web Developer located in Warsaw, Poland. I started my sole business back in 2016, offering services for companies all over the world since then. </p>
							<div class="row">
								<div class="col-2">
									<span>PHONE</span>
								</div>
								<div class="col-8">
									<a href="tel:0048518523478">+48 518 523 478</a>
								</div>
							</div>
							<div class="row">
								<div class="col-2">
									<span>EMAIL</span>
								</div>
								<div class="col-8">
									<a href="mailto:contact@sekvoia.co">contact@sekvoia.co</a>
								</div>
							</div>
							<div class="row">
								<div class="col-2">
									<span>ADDRESS</span>
								</div>
								<div class="col-8">
									ul. Uznamska 8/72, 03-477 Warszawa
								</div>
							</div>
						</div>
						<div class="col-6">
							image	
						</div>
					</div>

				</div>
				<hr>
				<div class="container">
					<div class="row">
						<div class="col-4">
							<h1>Skills</h1>
							<p>I am i</p>
						</div>
						<div class="col-8">
							<div class="row">
													<div class="col-6">
						<h5>Frontend Development</h5>
						<p>AngularJS, Angular 2+, Vue.js, HTML, CSS, LESS, SASS, Bootstrap</p>
					</div>
					<div class="col-6">
						<h5>Backend Development</h5>
						<p>Node.js, Express, Hapi.js, MongoDB, SQL, Redis, Zend Framework, Drupal, Wordpress, Yii</p>
					</div>
					<div class="col-6">
						<h5>UI/UX Design</h5>
						<p>Photoshop, Sketch, Prototyping, Wireframing, Usuablity Testing</p>
					</div>
							</div>
						</div>
					</div>
				</div>


                <div class="container">
					<div class="mb-4">
						<h1>Tomasz Zaborski</h1>
						<p class="mb-4">Born on 29 August 1990 in Nowe Miasto nad Pilica</p>
					</div>

					<div class="mb-4">
						<div class="row">
							<div class="col-3">
								Residence:
							</div>
							<div class="col-4">
								ul. Uznamska 8/72, 03-475 Warszawa
							</div>
						</div>
						<div class="row">
							<div class="col-3">
								Contact:
							</div>
							<div class="col-5">
								tel. 518 523 478, <a href="mailto:contact@sekvoia.co">contact@sekvoia.co</a>
							</div>
						</div>
					</div>

					<h2>Education</h2>

					<div class="mb-4">
						<div class="row mb-2">
							<div class="col-3">
								2012 - 2018
							</div>
							<div class="col-5">
								Polish-Japanese Academy of Information Technology, Warsaw<br>
								Information Management, Project Management - BSc, Engineer
							</div>
						</div>
						<div class="row mb-2">
							<div class="col-3">
								2006 - 2009
							</div>
							<div class="col-5">
								V LO im. Romuald Tragutt, Radom<br>
								Profile: IT & English
							</div>
						</div>
					</div>

					<h2>Career</h2>

					<div class="mb-4">
						<div class="row mb-2">
							<div class="col-3">
								January 2016 - Current
							</div>
							<div class="col-5">
								B2B Services<br>
								Web Development
							</div>
						</div>
						<div class="row mb-2">
							<div class="col-3">
								February 2012 - December 2015
							</div>
							<div class="col-5">
								Gorilla Media, Warsaw<br>
								Front End Developer / Project Leader
							</div>
						</div>
						<div class="row mb-2">
							<div class="col-3">
								September 2011 - January 2012
							</div>
							<div class="col-5">
								Wyspa Kreatywna, Warsaw<br>
								Web Developer
							</div>
						</div>
						<div class="row mb-2">
							<div class="col-3">
								February 2009 - September 2011
							</div>
							<div class="col-5">
								Alpha Flight, Airport Cargo, Birmingham, United Kingdom<br>
								General Assistant
							</div>
						</div>
						<div class="row mb-2">
							<div class="col-3">
								August 2009 - January 2010
							</div>
							<div class="col-5">
								Freelance<br>
								Web Developer
							</div>
						</div>
						<div class="row mb-2">
							<div class="col-3">
								July 2008 - September 2008
							</div>
							<div class="col-5">
								Onefaceone.com, London, United Kingdom<br>
								Web Developer
							</div>
						</div>
					</div>

					<h2>Languages</h2>

					<p>English - Intermediade level, spoken and written</p>
					<p>German - Beginner level, spoken and written</p>

					<h2>Abilities</h2>
					<ul>
						<li>AngularJS, Vue.js, Angular 2+, Backbone.js</li>
						<li>Zend Framework, Drupal</li>
						<li>GruntJS, Webpack</li>
						<li>SQL, NoSQL</li>
						<li>Visual Studio, ASP .NET MVC, .NET Core</li>
						<li>GIT, SVN and TFS</li>
					</ul>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
export default {
  name: "about",
  components: {}
};
</script>
<style lang="scss">
</style>
